<template>
  <div class="download-page">
    <div class="download-container">
      <el-form inline class="elementui-common-form-styles" label-width="40px" v-highlight>
        <el-form-item label="页面">
          <el-select v-model="form.pageTypeList" placeholder="全部" clearable collapse-tags multiple filterable>
            <el-option v-for="item in PAGE_TYPE_LIST" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="创建人" label-width="50px">
          <el-select v-model="form.createOpIdList" placeholder="全部" clearable collapse-tags multiple filterable>
            <el-option v-for="item in sysUsers" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态">
          <el-select v-model="form.downloadStatusList" placeholder="全部" clearable collapse-tags multiple filterable>
            <el-option
              v-for="item in [
                { id: 2, name: '未开始' },
                { id: 1, name: '进行中' },
                { id: 4, name: '失败' },
                { id: 3, name: '已完成' }
              ]"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="创建时间" label-width="80px">
          <el-date-picker
            v-model="form.daterange"
            style="width: 280px"
            type="daterange"
            range-separator="~"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item class="bg-transparent">
          <el-button type="primary" @click="queryAction" :loading="pager.loading">查询</el-button>
        </el-form-item>
      </el-form>
      <Viewport v-model="downloadCenterTableHeight">
        <el-table
          v-loading="pager.loading"
          class="common-el-table-styles"
          :data="tableData"
          :height="downloadCenterTableHeight"
          border
          style="width: 100%"
        >
          <el-table-column prop="id" label="任务ID" width="60"> </el-table-column>
          <el-table-column prop="taskName" show-overflow-tooltip label="任务名称" width="280"> </el-table-column>
          <el-table-column label="页面">
            <template slot-scope="{ row }">
              <div>{{ PAGE_TYPE_LIST.find((item) => item.id === row.pageType).name }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="状态" width="80">
            <template slot-scope="{ row }">
              <div>
                {{
                  row.downloadStatus === 1 ? '进行中' : row.downloadStatus === 2 ? '未开始' : row.downloadStatus === 3 ? '已完成' : '失败'
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="查询条件" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <div>
                {{ row.queryCondition.conditionText }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="140">
            <template slot-scope="{ row }">
              <div>
                {{ moment(row.createTime).format('YYYY-MM-DD HH:mm:ss') }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="完成时间" width="140">
            <template slot-scope="{ row }">
              <div>
                {{ row.downloadFinishTime && moment(row.downloadFinishTime).format('YYYY-MM-DD HH:mm:ss') }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="opName" label="创建人" width="110"> </el-table-column>
          <el-table-column label="操作" width="60">
            <template slot-scope="{ row }">
              <el-button type="text" v-if="row.downloadStatus === 3" :loading="row.downloadLoading" @click="getFile(row)">下载</el-button>
              <!-- <el-button type="text" v-else @click="retry(row)">重试</el-button> -->
            </template>
          </el-table-column>
        </el-table>

        <div class="pager">
          <el-pagination
            :current-page.sync="pager.pageIndex"
            :page-size.sync="pager.pageSize"
            :total="pager.total"
            @current-change="getPageList"
            layout="prev, pager, next"
            background
          >
          </el-pagination>
        </div>
      </Viewport>
    </div>
  </div>
</template>

<script setup>
import store from '@/store'
import { setLocal } from '@/common/js/api.js'
import { ref, computed, set, onBeforeMount } from 'vue'
import { HOST_API } from '@/api/config'
import { PAGE_TYPE_LIST } from './data/const.js'
import { transferTaskQueryConditions } from './data/utils.js'
import moment from 'moment'
import { getDownloadCenterByPage, getDownloadCenterFileByTask } from '@/api/report.model'
import { initPageData, SYS_USERS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS])

const sysUsers = computed(PAGE_REQUIRED_OPTS.SYS_USERS)
const downloadCenterTableHeight = ref(300)
const tableData = ref([])
const pager = ref({
  pageIndex: 1,
  pageSize: 50,
  total: 0,
  loading: false
})
const form = ref({
  pageTypeList: [],
  createOpIdList: [],
  downloadStatusList: [],
  daterange: []
})

onBeforeMount(() => {
  store.commit('setDownloadBadgeActive', 0)
})

function getPageList() {
  const { daterange, ...restParams } = form.value
  const [createStartTime = '', createEndTime = ''] = form.value.daterange || []
  pager.value.loading = true
  getDownloadCenterByPage({
    pageIndex: pager.value.pageIndex,
    pageSize: pager.value.pageSize,
    ...restParams,
    createStartTime,
    createEndTime
  })
    .then((data) => {
      const { datas, total } = data
      tableData.value = datas.map((d) => {
        const condition = JSON.parse(d.queryCondition)
        return { ...d, queryCondition: condition }
      })
      pager.value.total = total
      pager.value.loading = false
    })
    .catch(() => {
      pager.value.loading = false
    })
}
function queryAction() {
  pager.value.pageIndex = 1
  getPageList()
}
function retry(row) {
  console.log('row output: ', row)
}

function getFile(row) {
  set(row, 'downloadLoading', true)
  getDownloadCenterFileByTask(row.downloadFileName)
    .then((data) => {
      set(row, 'downloadLoading', false)
    })
    .catch(() => {
      set(row, 'downloadLoading', false)
    })
}

getPageList()
</script>

<style lang="scss" scoped>
.download-page {
  height: 100%;
  padding: 0 16px;

  .download-container {
    background: #fff;
    height: 100%;
    padding: 15px;
    border-radius: 4px;
  }

  .pager {
    text-align: right;
    padding: 10px 0;
  }
}
</style>
